import styled from '@emotion/styled';
import { List, ListProps } from '@portalterreno/react-ui-core/List';

type StyledListProps = ListProps & {
  isPlanListOpen?: boolean;
};

const StyledList = styled(List)<StyledListProps>(
  {
    position: 'absolute',
    top: 20,
    alignItems: 'flex-start',
    width: 'fit-content',
    a: {
      '&:link, &:visited': {
        color: 'inherit'
      }
    }
  },
  ({ theme, isPlanListOpen }) => ({
    backgroundColor: theme.palette.colors.white,
    display: isPlanListOpen ? 'visible' : 'hidden'
  })
);

export default StyledList;
